module.exports = __webpack_public_path__ + "img/logo.07411817.jpeg";